import { Api } from "@/config";
import Header from "@/models/header";
import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import { DELETE_HEADER, SET_HEADERS } from "@/store/mutation-types";

@Module({ namespaced: true })
export default class Headers extends VuexModule {
  public headers: Array<Header> = [];
  public predefinedHeaderKeys: { key: string }[] = [
    { key: "Accept" },
    { key: "Accept-Charset" },
    { key: "Accept-Datetime" },
    { key: "Accept-Encoding" },
    { key: "Accept-Language" },
    { key: "Access-Control-Request-Headers" },
    { key: "Access-Control-Request-Method" },
    { key: "Authorization" },
    { key: "Cache-Control" },
    { key: "Connection" },
    { key: "Content-MD5" },
    { key: "Content-Length" },
    { key: "Content-Transfer-Encoding " },
    { key: "Content-Type" },
    { key: "Cookie" },
    { key: "Cookie2" },
    { key: "Date" },
    { key: "DNT" },
    { key: "Expect" },
    { key: "From" },
    { key: "Host" },
    { key: "If-Match" },
    { key: "If-Modified-Since" },
    { key: "If-None-Match" },
    { key: "If-Range" },
    { key: "If-Unmodified-Since" },
    { key: "Keep-Alive" },
    { key: "Max-Forwards" },
    { key: "Origin" },
    { key: "Pragma" },
    { key: "Proxy-Authorization" },
    { key: "Range" },
    { key: "Referer" },
    { key: "TE" },
    { key: "Trailer" },
    { key: "Transfer-Encoding" },
    { key: "Upgrade" },
    { key: "User-Agent" },
    { key: "Via" },
    { key: "Warning" },
    { key: "x-api-key" },
    { key: "X-Requested-With" },
    { key: "X-Do-Not-Track" },
  ];

  //#region Actions
  @Action
  public get(): Promise<void> {
    return new Promise((resolve, reject) => {
      Api.get(`headers`).then(
        (response) => {
          if (response && response.status === 200) {
            let headers: Array<Header> = [];
            response.data.forEach((header: any) => {
              headers.push(new Header(header));
            });

            this.context.commit(SET_HEADERS, headers);
          }

          resolve();
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  @Action
  public update(postModel: Array<Header>): Promise<void> {
    return new Promise((resolve, reject) => {
      Api.put(`headers`, postModel).then(
        (response) => {
          if (response && response.status === 200) {
            let headers: Array<Header> = [];
            response.data.forEach((header: any) => {
              headers.push(new Header(header));
            });

            this.context.commit(SET_HEADERS, headers);
          }

          resolve();
        },
        (error) => {
          reject(error.response);
        }
      );
    });
  }

  @Action
  public delete(headerId: string) {
    return new Promise((resolve, reject) => {
      Api.delete(`headers/${headerId}`).then(
        (response) => {
          if (response && response.status === 200) {
            let headerToDelete = new Header(response.data);
            this.context.commit(DELETE_HEADER, headerToDelete);
          }

          resolve();
        },
        (error) => {
          reject(error.response);
        }
      );
    });
  }
  //#endregion

  //#region Getters
  //#endregion

  //#region Mutations
  @Mutation
  public [DELETE_HEADER](header: Header) {
    let index = this.headers.findIndex((lc) => lc.id === header.id);
    if (index > -1) {
      this.headers.splice(index, 1);
    }
  }

  @Mutation
  public [SET_HEADERS](headers: Array<Header>) {
    this.headers = headers;
  }
  //#endregion
}
